import React from "react";
import interfaceImg from "../../images/Assets/interfaceImg.png";

export default function Deploy() {
  return (
    <div className="interBg md:px-6 xl:px-10 px-28 py-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex md:flex-col flex-row items-center justify-center lg:gap-16 gap-32">
          <div className="w-full flex items-center justify-center">
            <img src={interfaceImg} alt="interfaceImg" />
          </div>

          <div className="w-full">
            <div className="bg-[#F4F2FE] text-[14px] text-[#5B2ED9] font-gilroySemibold uppercase w-fit py-0.5 px-2.5 rounded-full">
              White Labeled Solution
            </div>

            <div className="lg:text-[28px] text-[40px] text-[#0E062A] font-gilroySemibold lg:leading-tight leading-[52px] text-start mt-2">
              Deploy AI interface with <br className="xl:hidden block" /> your application
            </div>

            <div className="lg:text-[16px] text-[18px] text-[#544D68] font-gilroyRegular text-start mt-6">
              Lorem ipsum dolor sit amet consectetur. Enim gravida aliquam <br className="xl:hidden block" />{" "}
              sed elementum interdum. Etiam mauris lorem rutrum in aenean <br className="xl:hidden block" />{" "}
              porttitor dui fermentum. Pellentesque sagittis diam velit integer.{" "}
              <br className="xl:hidden block" />
              Et interdum id tortor viverra mi. Non lobortis suspendisse vitae{" "}
              <br className="xl:hidden block" /> id risus risus lectus nulla neque. Quis dapibus laoreet
              faucibus <br className="xl:hidden block" /> faucibus eu diam viverra consequat egestas. Tortor
              aliquet ut <br className="xl:hidden block" /> egestas aliquam ultricies eu eget viverra tempus.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
